export enum EThemeDefaultColors {
  PrimarySystemColor = 'primary_system_color',
  PrimaryAccentColor = 'primary_accent_color',
  PrimaryAccentSecondColor = 'primary_accent_second_color',
  ElementalHeaderColor = 'elemental_header_color',
  ElementalCallColor = 'elemental_call_color',
  SecondarySuccessColor = 'secondary_success_color',
  SecondaryErrorColor = 'secondary_error_color',
  SecondaryWarningColor = 'secondary_warning_color',
}

export const CThemeDefaultColors: { [key in EThemeDefaultColors]: string } = {
  [EThemeDefaultColors.PrimarySystemColor]: '#000D24',
  [EThemeDefaultColors.PrimaryAccentColor]: '#F2871F',
  [EThemeDefaultColors.PrimaryAccentSecondColor]: '#1D4ED8',
  [EThemeDefaultColors.ElementalHeaderColor]: '#000D24',
  [EThemeDefaultColors.ElementalCallColor]: '#000D24',
  [EThemeDefaultColors.SecondarySuccessColor]: '#21917F',
  [EThemeDefaultColors.SecondaryErrorColor]: '#C41A1E',
  [EThemeDefaultColors.SecondaryWarningColor]: '#EAB30B',
}
